import React from "react";
import "./style.css";

const AuditTrail = ({ message }) => {
  if (message.type === "status_change" || message.type === "events") {
    const highlightStyle = {
      color: "#148DFD",
      textAlign: "center",
      fontFamily: "Inter",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "12px",
    };

    if (
      message.type === "events" &&
      message.meta?.type === "assigneeChange" &&
      message.meta.value?.fromName &&
      message.meta.value?.toName
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              <span style={highlightStyle}>{message.meta.actor}</span>
              {` changed assignee from `}
              <span style={highlightStyle}>{message.meta.value.fromName}</span>
              {` to `}
              <span style={highlightStyle}>{message.meta.value.toName}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "statusChange" &&
      message.meta.value?.from &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` changed ticket status from `}
              <span style={highlightStyle}>{message.meta.value.from}</span>
              {` to `}
              <span style={highlightStyle}>{message.meta.value.to}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "priorityChange" &&
      message.meta.value?.from &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` changed ticket priority from `}
              <span style={highlightStyle}>{message.meta.value.from}</span>
              {` to `}
              <span style={highlightStyle}>{message.meta.value.to}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "customerEmailChange" &&
      message.meta.value?.from &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              <span style={highlightStyle}>{message.meta.actor}</span>
              {` changed requester email from `}
              <span style={highlightStyle}>
                {message.meta.value.from.slice(0, 30)}
                {message.meta.value.from.length > 30 ? "..." : ""}
              </span>
              {` to `}
              <span style={highlightStyle}>
                {message.meta.value.to.slice(0, 30)}
                {message.meta.value.to.length > 30 ? "..." : ""}
              </span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "customerNameChange" &&
      message.meta.value?.from &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              <span style={highlightStyle}>{message.meta.actor}</span>
              {` changed requester name from `}
              <span style={highlightStyle}>{message.meta.value.from}</span>
              {` to `}
              <span style={highlightStyle}>
                {message.meta.value.to.slice(0, 30)}
                {message.meta.value.to.length > 30 ? "..." : ""}
              </span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "ccEmailsAdded" &&
      Array.isArray(message.meta.value) &&
      message.meta.value.length > 0
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` added CC email: `}
              {message.meta.value.map((email, idx) => (
                <span key={email} style={highlightStyle}>
                  {email.slice(0, 30)}
                  {email.length > 30 ? "..." : ""}
                  {idx < message.meta.value.length - 1 ? ", " : ""}
                </span>
              ))}
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "ccEmailsRemoved" &&
      Array.isArray(message.meta.value) &&
      message.meta.value.length > 0
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` removed CC email: `}
              {message.meta.value.map((email, idx) => (
                <span key={email} style={highlightStyle}>
                  {email.slice(0, 30)}
                  {email.length > 30 ? "..." : ""}
                  {idx < message.meta.value.length - 1 ? ", " : ""}
                </span>
              ))}
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "tagsAdded" &&
      Array.isArray(message.meta.value) &&
      message.meta.value.length > 0
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` added tag: `}
              {message.meta.value.map((tag, idx) => (
                <span key={tag} style={highlightStyle}>
                  {tag}
                  {idx < message.meta.value.length - 1 ? ", " : ""}
                </span>
              ))}
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "firstAssignee" &&
      message.meta.value?.to !== "unassigned" &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && message.meta.actor && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {message.meta && message.meta.actor
                ? ` assigned ticket to `
                : `Ticket assigned to `}
              <span style={highlightStyle}>{message.meta.value.to}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "firstAssignee" &&
      message.meta.value?.to === "unassigned" &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              Ticket <span style={highlightStyle}>unassigned</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "selfAssignee" &&
      message.meta.value?.to &&
      message.meta.actor
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              <span style={highlightStyle}>{message.meta.actor}</span>
              {` assigned the ticket to `}
              <span style={highlightStyle}>themselves</span>
            </span>
          </div>

          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "groupChange" &&
      message.meta.value &&
      (Array.isArray(message.meta.value.added) ||
        Array.isArray(message.meta.value.removed))
    ) {
      const addedGroups = Array.isArray(message.meta.value.added)
        ? message.meta.value.added
        : [];
      const removedGroups = Array.isArray(message.meta.value.removed)
        ? message.meta.value.removed
        : [];
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {message.meta && message.meta.actor && (
                <span style={highlightStyle}>{message.meta.actor}</span>
              )}
              {` updated ticket groups.`}
              {addedGroups.length > 0 && (
                <>
                  {` Added: `}
                  {addedGroups.map((group, idx) => (
                    <span key={group.id} style={highlightStyle}>
                      {group.name}
                      {idx < addedGroups.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </>
              )}
              {removedGroups.length > 0 && (
                <>
                  {` Removed: `}
                  {removedGroups.map((group, idx) => (
                    <span key={group.id} style={highlightStyle}>
                      {group.name}
                      {idx < removedGroups.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </>
              )}
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "agentReply" &&
      message.meta.value?.from &&
      message.meta.value?.to &&
      message.agent?.full_name
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {`Ticket status changed  from `}
              <span style={highlightStyle}>{message.meta.value.from}</span>
              {` to `}
              <span style={highlightStyle}>{message.meta.value.to}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "customerReply" &&
      message.meta.value?.from &&
      message.meta.value?.to
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              {`Ticket status changed from `}
              <span style={highlightStyle}>{message.meta.value.from}</span>
              {` to `}
              <span style={highlightStyle}>{message.meta.value.to}</span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    if (
      message.type === "events" &&
      message.meta?.type === "subjectChange" &&
      message.meta.value?.from &&
      message.meta.value?.to &&
      message.meta.actor
    ) {
      return (
        <div className=" status-change-message">
          <div className="left-line"></div>
          <div className="message-time">
            <span className="status-text">
              <span style={highlightStyle}>{message.meta.actor}</span>
              {` changed subject from `}
              <span style={highlightStyle}>
                {message.meta.value.from && message.meta.value.from.length > 30
                  ? message.meta.value.from.slice(0, 30) + "..."
                  : message.meta.value.from}
              </span>
              {` to `}
              <span style={highlightStyle}>
                {message.meta.value.to && message.meta.value.to.length > 30
                  ? message.meta.value.to.slice(0, 30) + "..."
                  : message.meta.value.to}
              </span>
            </span>
          </div>
          <div className="right-line"></div>
        </div>
      );
    }

    return (
      <>
        {message.type === "events" && (
          <div className=" status-change-message">
            <div className="left-line"></div>
            <div className="message-time">
              <span className="status-text">
                {message.type === "events" && message?.message}
              </span>
            </div>
            <div className="right-line"></div>
          </div>
        )}
      </>
    );
  }
  return null;
};

export default AuditTrail;
